import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const FLAG = { CZ: '🇨🇿', SK: '🇸🇰', RO: '🇷🇴', DE: '🇩🇪', AT: '🇦🇹', PL: '🇵🇱' };

export default function ExhibitionsPage() {
  const { lang, t, apiFetch } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/exhibitions').then(setItems).finally(() => setLoading(false));
  }, [apiFetch]);

  const locale = lang === 'cs' ? 'cs-CZ' : lang === 'sk' ? 'sk-SK' : 'ro-RO';

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>{t('loading')}</div>;

  return (
    <div>
      <h1 style={{ margin: '0 0 24px', fontSize: 26, fontWeight: 800, color: '#111827' }}>
        🏛️ {t('exhibitionsTitle')}
      </h1>

      {items.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>{t('noExhibitions')}</div>
      ) : (
        <div style={{ display: 'grid', gap: 16 }}>
          {items.map(item => {
            const title = item[`title_${lang}`] || item.title_cs;
            const desc = item[`description_${lang}`] || item.description_cs;
            const dateFrom = new Date(item.date_from);
            const dateTo = item.date_to ? new Date(item.date_to) : null;
            const isUpcoming = dateFrom > new Date();
            const flag = FLAG[item.country] || '🌍';

            return (
              <div key={item.id} style={{
                background: '#fff',
                borderRadius: 12,
                padding: '24px',
                boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
                border: `1px solid ${isUpcoming ? '#b3d9f2' : '#f3f4f6'}`,
                borderLeft: `4px solid ${isUpcoming ? '#0e76bc' : '#e5e7eb'}`,
                display: 'grid',
                gridTemplateColumns: '1fr auto',
                gap: 16,
                alignItems: 'start',
              }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                    {isUpcoming && (
                      <span style={{
                        background: '#e8f4fc',
                        color: '#0e76bc',
                        fontSize: 11,
                        fontWeight: 700,
                        padding: '2px 8px',
                        borderRadius: 6,
                      }}>
                        {t('upcoming')}
                      </span>
                    )}
                    <span style={{ fontSize: 18 }}>{flag}</span>
                  </div>
                  <h2 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 700, color: '#111827' }}>
                    {title}
                  </h2>
                  {desc && <p style={{ margin: '0 0 12px', fontSize: 14, color: '#6b7280', lineHeight: 1.6 }}>{desc}</p>}

                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 20px' }}>
                    <span style={{ fontSize: 13, color: '#374151' }}>
                      📅 {dateFrom.toLocaleDateString(locale)}{dateTo ? ' – ' + dateTo.toLocaleDateString(locale) : ''}
                    </span>
                    <span style={{ fontSize: 13, color: '#374151' }}>📍 {item.location}</span>
                    {item.booth && <span style={{ fontSize: 13, color: '#374151' }}>🏷️ {t('booth')}: {item.booth}</span>}
                    {item.organizer_name && <span style={{ fontSize: 13, color: '#0e76bc', fontWeight: 600 }}>🏢 {item.organizer_name}</span>}
                  </div>
                </div>

                {item.website_url && (
                  <a
                    href={item.website_url}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      background: '#f9fafb',
                      border: '1px solid #e5e7eb',
                      color: '#374151',
                      fontSize: 13,
                      fontWeight: 600,
                      padding: '8px 14px',
                      borderRadius: 8,
                      textDecoration: 'none',
                      whiteSpace: 'nowrap',
                      transition: 'all 0.15s',
                      display: 'block',
                    }}
                    onMouseEnter={e => { e.target.style.background = '#e8f4fc'; e.target.style.borderColor = '#fca5a5'; e.target.style.color = '#0e76bc'; }}
                    onMouseLeave={e => { e.target.style.background = '#f9fafb'; e.target.style.borderColor = '#e5e7eb'; e.target.style.color = '#374151'; }}
                  >
                    {t('website')} →
                  </a>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
